export default __webpack_public_path__ + "static/media/nft4.b79d94e5.gif";